import React from 'react';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';

/* ===== Components ===== */
import Team from './Team';
import Dmmsg from './DMssg';

function TeamPage() {
    return (
        <div className="font-sans text-slate-900 bg-slate-50 min-h-screen selection:bg-blue-100 selection:text-blue-900 antialiased">
            
            {/* --- HERO HEADER --- */}
            <div className="relative w-full pb-32 pt-40 px-6 flex flex-col items-center justify-center overflow-hidden min-h-[550px]">
                
                {/* Light base */}
                <div className="absolute inset-0 z-0 bg-white" />

                {/* Soft blue-grey gradient wash */}
                <div className="absolute inset-0 z-0 bg-gradient-to-br from-slate-50 via-blue-50/60 to-indigo-50/80" />

                {/* Radial glow — warm centre bloom */}
                <div className="absolute inset-0 z-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_10%,rgba(191,219,254,0.55),transparent)]" />

                {/* Subtle dot grid */}
                <div
                    className="absolute inset-0 z-0 opacity-[0.18]"
                    style={{
                        backgroundImage: 'radial-gradient(circle, #94a3b8 1px, transparent 1px)',
                        backgroundSize: '28px 28px',
                    }}
                />

                {/* Bottom fade into page bg */}
                <div className="absolute inset-0 z-0 bg-gradient-to-b from-transparent via-transparent to-slate-50/90" />

                {/* Thin top accent line */}
                <div className="absolute top-0 left-0 right-0 z-0 h-[3px] bg-gradient-to-r from-transparent via-blue-500 to-transparent" />

                {/* Content */}
                <div className="max-w-4xl mx-auto relative z-10 text-center">
                    
                    {/* Tag */}
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-md border border-blue-100 mb-6 shadow-md"
                    >
                        <Users className="text-blue-500 w-4 h-4" />
                        <span className="text-blue-700 text-xs font-bold tracking-widest uppercase">
                            Leadership & Management
                        </span>
                    </motion.div>
                    
                    {/* Main Heading */}
                    <motion.h1 
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
                        className="text-5xl md:text-7xl font-extrabold text-slate-900 leading-tight mb-6 tracking-tight"
                    >
                        Meet the{' '}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
                            Visionaries
                        </span>
                    </motion.h1>
                    
                    {/* Subtitle */}
                    <motion.p 
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                        className="text-slate-500 text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed"
                    >
                        Guided by academic excellence and industry expertise, our Board and Management team 
                        are dedicated to fostering the next generation of deep-tech entrepreneurs.
                    </motion.p>
                </div>
            </div>

            {/* --- CONTENT SECTIONS --- */}
            <div id="directors" className="relative z-20 w-full -mt-24">
                <Dmmsg />
                <Team />
            </div>

        </div>
    )
}

export default TeamPage;